import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import { useProtectedRoute } from "./useProtectedRoute";
import { Spinner } from "../../../common/components/Spinner";

export interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isPermittedRoute, userGrants } = useProtectedRoute();

  if (!userGrants) {
    return (
      <Box sx={{ height: "100vh" }}>
        <Spinner height="100%" />
      </Box>
    );
  }

  if (!isPermittedRoute) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};
